// extracted by mini-css-extract-plugin
export default {"table":"styles_table__iZcz9","number":"styles_number__1fsNs","image":"styles_image__z-Dx1","name":"styles_name__tQVvm","items":"styles_items__W+nN7","icon":"styles_icon__qIY9z"};